// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accordion-main-header {
  padding: 12px 40px 12px 16px;
  background-color: var(--grey-light4);
  border: 1px solid var(--grey-light1);
  margin-bottom: 4px;
  position: sticky;
  top: 80px;
  z-index: 1; }
  @media all and (max-width: 991px) {
    .accordion-main-header {
      top: 128px; } }

.primary-header {
  background-color: var(--primary-20); }

.title {
  color: var(--primary-100); }

.primary-header {
  background-color: var(--primary-20); }

.title {
  color: var(--primary-100); }

.accordion-line-chart {
  height: 100% !important;
  max-height: 250px;
  padding: 24px;
  max-width: 75%;
  width: 100% !important;
  margin: 0 auto; }
  @media all and (max-width: 767px) {
    .accordion-line-chart {
      max-width: 100%;
      padding: 24px 16px; } }

.result-section {
  margin: 24px 0;
  border: 1px solid var(--grey-light2);
  border-radius: 16px;
  padding: 20px 32px 12px;
  position: relative;
  box-shadow: 0 1px 12px 1px rgba(0, 0, 0, 0.15); }
  .result-section .key-header {
    position: absolute;
    top: -16px;
    left: 24px;
    width: -moz-fit-content;
    width: fit-content;
    border-radius: 8px;
    background-color: var(--grey-light3); }
  .result-section .progress-container {
    max-width: 500px; }
  .result-section:not(:first-child) {
    margin-top: 32px; }

.loader {
  height: calc(100vh - 210px); }

.empty-list-page {
  height: calc(100vh - 265px);
  display: flex;
  align-items: center;
  justify-content: center; }

/* Progress bar styles here */
.ant-progress.below50 .ant-progress-bg {
  background-color: red; }

.ant-progress.below80 .ant-progress-bg {
  background-color: yellow; }

.ant-progress.above80 .ant-progress-bg {
  background-color: green; }

.ant-progress.objProgress .ant-progress-bg {
  background-color: #4f70d1; }
`, "",{"version":3,"sources":["webpack://./src/component/accordion/accordion.scss"],"names":[],"mappings":"AAAA;EACI,4BAA4B;EAC5B,oCAAoC;EACpC,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,UAAU,EAAA;EACV;IARJ;MASQ,UAAU,EAAA,EAEjB;;AACD;EACI,mCAAmC,EAAA;;AAEvC;EACI,yBAAyB,EAAA;;AAG7B;EACI,mCAAmC,EAAA;;AAGvC;EACI,yBAAyB,EAAA;;AAG7B;EACI,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,cAAc,EAAA;EACd;IAPJ;MAQQ,eAAe;MACf,kBAAkB,EAAA,EAEzB;;AAGD;EACI,cAAc;EACd,oCAAoC;EACpC,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,8CAA8C,EAAA;EANlD;IAQQ,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,uBAAkB;IAAlB,kBAAkB;IAClB,kBAAkB;IAClB,oCAAoC,EAAA;EAb5C;IAgBQ,gBAAgB,EAAA;EAhBxB;IAmBQ,gBAAgB,EAAA;;AAIxB;EACI,2BAA2B,EAAA;;AAG/B;EACI,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB,EAAA;;AAE3B,6BAAA;AACA;EAGQ,qBAAqB,EAAA;;AAH7B;EAQQ,wBAAwB,EAAA;;AARhC;EAaQ,uBAAuB,EAAA;;AAb/B;EAkBS,yBAAyB,EAAA","sourcesContent":[".accordion-main-header {\n    padding: 12px 40px 12px 16px;\n    background-color: var(--grey-light4);\n    border: 1px solid var(--grey-light1);\n    margin-bottom: 4px;\n    position: sticky;\n    top: 80px;\n    z-index: 1;\n    @media all and (max-width: 991px) {\n        top: 128px;\n    }\n}\n.primary-header {\n    background-color: var(--primary-20);\n}\n.title {\n    color: var(--primary-100);\n}\n\n.primary-header {\n    background-color: var(--primary-20);\n}\n\n.title {\n    color: var(--primary-100);\n}\n\n.accordion-line-chart {\n    height: 100% !important;\n    max-height: 250px;\n    padding: 24px;\n    max-width: 75%;\n    width: 100% !important;\n    margin: 0 auto;\n    @media all and (max-width: 767px) {\n        max-width: 100%;\n        padding: 24px 16px;\n    }\n}\n\n\n.result-section {\n    margin: 24px 0;\n    border: 1px solid var(--grey-light2);\n    border-radius: 16px;\n    padding: 20px 32px 12px;\n    position: relative;\n    box-shadow: 0 1px 12px 1px rgba(0, 0, 0, 0.15);\n    .key-header {\n        position: absolute;\n        top: -16px;\n        left: 24px;\n        width: fit-content;\n        border-radius: 8px;\n        background-color: var(--grey-light3);\n    }\n    .progress-container {\n        max-width: 500px;\n    }\n    &:not(:first-child) {\n        margin-top: 32px;\n    }\n}\n\n.loader {\n    height: calc(100vh - 210px);\n}\n\n.empty-list-page {\n    height: calc(100vh - 265px);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n/* Progress bar styles here */\n.ant-progress {\n &.below50 {\n    .ant-progress-bg {\n        background-color: red;\n    }\n }   \n &.below80 {\n    .ant-progress-bg {\n        background-color: yellow;\n    }\n }\n &.above80 {\n    .ant-progress-bg {\n        background-color: green;\n    }\n }\n &.objProgress {\n     .ant-progress-bg {\n         background-color: #4f70d1;\n     }\n }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
